import { Button, darken } from '@mui/material';
import { forwardRef } from 'react';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  actionButton: {
    minWidth: '7.5em',
    minHeight: '7em',
    flex: 1,
    flexDirection: 'column',
    borderRadius: 12,
    padding: '1rem 0.25rem',
    width: '6.5em',
    gap: 4,
    boxShadow: 'none',
    // background: `linear-gradient(to bottom, ${theme.palette.primary.main} , ${darken(
    //   theme.palette.primary.main,
    //   0.25,
    // )})`,
    transition: 'background 0.1s ease',
    border: `2px solid ${theme.palette.primary.main}`,
    '@container (max-width: 480px)': {
      minHeight: '5em',
      padding: '0.5rem 0.25rem',
    },

    '&:hover': {
      background: `linear-gradient(to bottom, ${theme.palette.primary.main} , ${darken(
        theme.palette.primary.main,
        0.7,
      )})`,
      filter: 'brightness(1.2)',
      // background: '#00000063',
    },
  },
  actionLabel: {
    fontWeight: 400,
    color: '#fff',
    fontSize: '0.75rem',
    marginTop: 2,
    lineHeight: 1,
  },
}));

interface ActionButtonProps {
  iconType: React.ElementType;
  label: string;
  onClick: () => void;
  id?: string;
}

const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(
  ({ iconType, label, onClick, id }, ref) => {
    const { classes } = useStyles();
    const Icon = iconType;

    return (
      <Button ref={ref} id={id} className={classes.actionButton} data-testid={id} onClick={onClick}>
        <Icon fontSize="large" sx={{ color: '#fff' }} />
        <span className={classes.actionLabel}>{label}</span>
      </Button>
    );
  },
);

ActionButton.displayName = 'ActionButton';

export default ActionButton;
